import { Schema } from 'yup';
import { SignUpFlowScreens } from '@pharmaplan/common';
import strings from '../../localization';
import {
  ContactValidator,
  GeneralValidator,
  professionalCorporatedValidator,
  ProfessionalValidator,
  SoftwareValidator,
} from './PharmacistSignupFlow/Validator';
import {
  accountingValidator,
  coordinateValidator,
  pharmacyInfoValidator,
  primaryValidator,
  secondaryValidator,
} from './PharmacySignupFlow/Validator';

type Steps = Record<
  any,
  { type: string; label: string; validator?: Schema; screenName: string }
>;

const {
  General,
  ProfessionalInfo,
  Contact,
  Software,
  Primary,
  Secondary,
  Accounting,
  PharmacyInfo,
  Coordinates,
} = SignUpFlowScreens;

export const toAnalyticsStepNumber = (step: number) =>
  step + 1;

export const pharmacistSteps = (): Steps =>
  ({
    0: {
      type: 'general',
      screenName: General,
      label: strings.general,
      validator: GeneralValidator(),
    },
    1: {
      type: 'professionalInfo',
      screenName: ProfessionalInfo,
      label: strings.professionalInfo,
      validator: ProfessionalValidator(),
    },
    2: {
      type: 'selectedSoftwares',
      screenName: Software,
      label: strings.software,
      validator: SoftwareValidator(),
    },
    3: {
      type: 'contacts',
      screenName: Contact,
      label: strings.contact,
      validator: ContactValidator(),
    },
  });

export const professionalSteps = (): Steps =>
  ({
    0: {
      type: 'general',
      screenName: General,
      label: strings.general,
      validator: GeneralValidator(),
    },
    1: {
      type: 'professionalInfo',
      screenName: ProfessionalInfo,
      label: strings.professionalInfo,
      validator: professionalCorporatedValidator(),
    },
    2: {
      type: 'selectedSoftwares',
      screenName: Software,
      label: strings.software,
      validator: SoftwareValidator(),
    },
    3: {
      type: 'contacts',
      screenName: Contact,
      label: strings.contact,
      validator: ContactValidator(),
    },
  });

export const pharmacySteps = (): Steps =>
  ({
    0: {
      type: 'pharmacyInfo',
      screenName: PharmacyInfo,
      label: strings.general,
      validator: pharmacyInfoValidator(),
    },
    1: {
      type: 'coordinates',
      screenName: Coordinates,
      label: strings.coordinates,
      validator: coordinateValidator(),
    },
    2: {
      type: 'primary',
      screenName: Primary,
      label: strings.primary,
      validator: primaryValidator(),
    },
    3: {
      type: 'secondary',
      screenName: Secondary,
      label: strings.secondary,
      validator: secondaryValidator(),
    },
    4: {
      type: 'accounting',
      screenName: Accounting,
      label: strings.accounting,
      validator: accountingValidator(),
    },
  });
